import React, { memo, type ReactElement, useCallback, useState } from 'react';
import { batch, useDispatch } from 'react-redux';

import { SodWidget } from '../../../../shared/components';
import { RENDER_MODES, WIDGET_ACTION } from '../../../../shared/constants';
import {
  useInvertedLocalize,
  useTypedSelector,
} from '../../../../shared/hooks';
import { type ActiveWidgetItem } from '../../../../shared/types';
import { violationsTabActions } from '../../data-store/violationsTabSlice';

import ViolationsWidgetMenu from './ViolationsWidgetMenu';

import './ViolationsWidgets.css';

/**
 * Violations Widgets
 */
function ViolationsWidgets(): ReactElement {
  const l = useInvertedLocalize();
  const dispatch = useDispatch();
  const { widgets, tabInAction } = useTypedSelector(
    (state) => state.aag.violationsTab.controls
  );

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const activeWidgets = widgets.filter((widget) => widget.isChecked);

  const handleAction = (action: string, value: string) => {
    if (action === WIDGET_ACTION.HIDE) {
      const modifiedWidgets = widgets.map((widget) => ({
        ...widget,
        isChecked: value === widget.value ? false : widget.isChecked,
      }));

      dispatch(violationsTabActions.setWidgets(modifiedWidgets));

      return;
    }

    setIsMenuOpen(true);
  };

  const handleClick = useCallback(
    (activeItem: ActiveWidgetItem) => {
      batch(() => {
        dispatch(violationsTabActions.setIsInsightsOpen(false));
        dispatch(violationsTabActions.setActiveGraphPoint(null));
        dispatch(violationsTabActions.setActiveInsight(null));
        dispatch(violationsTabActions.setGraphRowContext(null));
        dispatch(violationsTabActions.setActiveWidgetItem(activeItem));

        setTimeout(
          () => dispatch(violationsTabActions.setRenderMode(RENDER_MODES.LIST)),
          50
        );
      });
    },
    [dispatch]
  );

  return (
    <section className='Sod-ViolationsTabWidgets-wrapper'>
      <ViolationsWidgetMenu
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
      {activeWidgets.map((widget) => (
        <SodWidget
          key={widget.value}
          kind={widget.kind}
          widgetSource={{ ...widget, label: l(widget.label) }}
          currentTab={tabInAction}
          onAction={handleAction}
          handleClick={handleClick}
        />
      ))}
    </section>
  );
}

export default memo(ViolationsWidgets);
